import { useQuery } from '@tanstack/react-query';
import { STALE_TIME } from 'infrastructure/consts/stale-time';
import { rangeTypesDataSource } from 'infrastructure/data-sources/range-type';

import useApi from '../use-api';

import type {
  ISmsMetricsFilters,
  ISmsMetricIntervalData,
} from 'infrastructure/interfaces';

type MetricType = 'status' | 'type' | 'inbound-outbound';

const api = (type: MetricType) => `core-2/sms-metrics/${type}-metrics`;

const prepareFilters = (filters: ISmsMetricsFilters) => {
  const rangeType = rangeTypesDataSource().find(
    (el) => el.id === filters.rangeType,
  );
  const newFilters: any = structuredClone(filters);
  delete newFilters.rangeType;
  if (rangeType) {
    Object.assign(newFilters, { interval: rangeType.interval });
  }
  return newFilters;
};

export const useGetSmsIntervalMetrics = (
  filters: ISmsMetricsFilters,
  metricType: MetricType,
  enabled = true,
) => {
  const queryKey = [
    'useGetSmsIntervalMetrics',
    filters.startTime,
    filters.endTime,
    filters.smsType,
    filters.status,
    metricType,
  ] as const;

  const { loadData } = useApi();

  const {
    data = [],
    error,
    isLoading,
  } = useQuery<ISmsMetricIntervalData>({
    queryKey,
    staleTime: STALE_TIME,
    queryFn: async () => {
      const res = await loadData<ISmsMetricIntervalData>(
        api(metricType),
        prepareFilters(filters),
      );
      if (res) return res;
      return [];
    },
    enabled,
  });

  return {
    data,
    isLoading,
    error,
  };
};
